import { useQuery } from '@tanstack/react-query';
import getLessonDetailsById from '../query';

const useGetLesson = (id: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['lesson', id],
    queryFn: () => getLessonDetailsById(id),
  });

  return { data, isLoading, error };
};

export default useGetLesson;
